module.exports = __webpack_public_path__ + "img/itop2.25127b78.png";